import { render, staticRenderFns } from "./InboxCard.vue?vue&type=template&id=591be1b8&"
import script from "./InboxCard.vue?vue&type=script&lang=js&"
export * from "./InboxCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports